import React from 'react';
import { makeStyles, mergeClasses } from '@fluentui/react-components';
import { IQuestion, ISiteMapNode } from '@bingads-webui/search-utils';
import { withQuestions } from '@bingads-webui-react/msa-copilot-common';
import { CopilotWelcomeTile } from '../copilot-welcome-tile';

export interface ICopilotWelcomeTileListProps {
  className?: string;
  onClick: (event: React.SyntheticEvent<HTMLDivElement, Event>, question: IQuestion) => void;
  onRenderWelcomeTile?: (question: IQuestion) => void;
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '8px',
  },
});

export const CopilotWelcomeTileList = (props: ICopilotWelcomeTileListProps & { questions: IQuestion[] }) => {
  const classes = useStyles();
  const {
    className,
    onClick,
    onRenderWelcomeTile,
    questions,
  } = props;

  return (
    <div className={mergeClasses('copilot-welcome-tile-list', classes.root, className)}>
      {questions.map((question) => (
        <CopilotWelcomeTile
          key={question.text}
          category={question.category}
          onClick={(ev) => onClick(ev, question)}
          onRenderWelcomeTile={() => {onRenderWelcomeTile && onRenderWelcomeTile(question)}}
          text={question.text}
        />
      ))}
    </div>
  );
};

export const CopilotWelcomeTileListWithQuestions = (props: ICopilotWelcomeTileListProps & { siteMap: ISiteMapNode[] }) => (
  withQuestions({ ...props, Component: CopilotWelcomeTileList }));
